import Vue from 'vue'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import Notifications from 'vue-notification'
import VueInputMask from 'vue-inputmask'
import Vuelidate from 'vuelidate'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
// import VueFullscreen from 'vue-fullscreen'
// https://dobromir-hristov.github.io/vuelidate-error-extractor/other_frameworks.html#usage-with-bootstrapvue
import VuelidateErrorExtractor, { templates } from "vuelidate-error-extractor";
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import FormGroup from '@components/FormGroup'
import FormSummary from '@components/FormSummary'
import CodeBase from '@plugins/codeBase'
import BootstrapVue from 'bootstrap-vue'
import i18n from '@plugins/i18n'
import { fabric } from 'fabric';
import VueTheMask from 'vue-the-mask'


import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

// https://dobromir-hristov.github.io/vuelidate-error-extractor/other_frameworks.html#usage-with-bootstrapvue
import '@plugins/veeValidate'
import money from 'v-money'
import removeReadonlyPlugin from './plugins/removeReadonlyPlugin';

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.use(removeReadonlyPlugin);
Vue.use(money, { precision: 2 })
Vue.config.errorHandler = function (err, vm, info) {
  console.error(`Error: `, err, ` Info: ${info}`);
  console.error("Stack:", err.stack)
  // console.log(`VM:`, vm);
}
Vue.config.warnHandler = function (msg, vm, trace) {
  console.log(`Warn: ${msg}\nTrace: ${trace}`);
}

import VueSweetalert2 from 'vue-sweetalert2'
// import 'sweetalert2/dist/sweetalert2.min.css'
Vue.use(VueSweetalert2);
Vue.use(VueTheMask)
Vue.use(BootstrapVue)
Vue.use(Datetime)
Vue.use(Vuelidate)
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

Vue.use(VuelidateErrorExtractor, {
  templates,
  i18n: 'validation'
});

Vue.use(Notifications)
Vue.use(CodeBase)
Vue.use(fabric)

Vue.use(VueLodash, { name: 'custom', lodash: lodash })
// Vue.use(VueFullscreen)

Vue.component("FormGroup", FormGroup);
Vue.component("FormSummary", FormSummary);
Vue.component("formWrapper", templates.FormWrapper);
Vue.component('datetime', Datetime);
Vue.use(VueInputMask.default);

// Vue.component('FontAwesomeIcon', FontAwesomeIcon)
// Vue.use(FontAwesomeIcon)
Vue.use(require('vue-moment'));

Vue.filter('substring', function (value, limit) {
  if (value.length > limit) {
    value = value.substring(0, limit);
  }
  return value
})

Vue.filter('minuscule', function (value) {
  return value.toLowerCase()
})

const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
